import { createFileRoute } from "@tanstack/react-router";

import { PresentationTemplates } from "@/features/settings";

/**
 * ``/settings/presentations`` — Brand Template System surface.
 *
 * Lists built-in + user/org-custom chrome / paper / writing-style templates,
 * lets the user pick a default, and opens an inline editor dialog to
 * create/edit custom rows. BE: ``/api/v1/presentation-templates``.
 */
export const Route = createFileRoute("/_authed/_modal/settings/presentations")({
  component: PresentationTemplates,
});
